import Privacy from '@/pages/Privacy.vue';

export default [
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: { layout: 'App' },
  },
];

